var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('addComp'),_vm._v(" "),_c('robotMap',{}),_vm._v(" "),_c('div',{staticClass:"robot1"},[_c('robotLeft',{})],1),_vm._v(" "),_c('div',{staticClass:"robot2"},[_c('robot2head',{}),_vm._v(" "),_c('robot2main',{})],1),_vm._v(" "),_c('div',{staticClass:"robot1"},[_c('robotRight',{})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-a2277374","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/main.vue
// module id = null
// module chunks = 